import React, { FC } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useObserver } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useRootStore } from '../../root/RootStoreHooks';

export const PaymentFailureModal: FC = () => {
  const rootStore = useRootStore();
  const completeEnrollmentStore = rootStore.moduleStores.completeEnrollmentProcessor!;
  const [t] = useTranslation();

  return useObserver(() => (
    <Modal show={completeEnrollmentStore.paymentErrorModal} backdrop="static">
      <Modal.Header>
        <Modal.Title>{t('PaymentErrorTitle')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{t('PaymentMethodError')}</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => completeEnrollmentStore.closePaymentErrorModalAndRedirect()}>
          {t('CheckPaymentMethodsButton')}
        </Button>
      </Modal.Footer>
    </Modal>
  ));
};
